<template>
  <form ref="form" class="rvr-data-form">
    <h2>{{ t.contact_person }}</h2>
    <span class="meta_text">{{ t.contact_person_meta }}</span>
    <div class="form-field">
      <InputText v-model="reservationData.contactPerson.name" name="contact_name" :label="t.contact_name" type="text" :min-length="2" :max-length="50" required/>
    </div>
    <div class="form-field">
      <InputText v-model="reservationData.contactPerson.phoneNumber" name="contact_phonenumber" :label="t.contact_phonenumber" type="text" :min-length="10" :max-length="15" required/>
    </div>
    <div class="form-field">
      <InputText v-model="reservationData.contactPerson.email" name="contact_email" :label="t.contact_email" type="email" :min-length="5" :max-length="254" required/>
    </div>
    <br/>
    <h2>{{ t.exhibitor_details }}</h2>
    <div class="form-field">
      <span class="field_warning_text">{{ t.exhibitor_companyname_meta }}</span>
      <InputText v-model="reservationData.exhibitorDetails.companyName" name="exhibitor_companyname" :label="t.exhibitor_companyname" type="text" :min-length="2" :max-length="100" required/>
    </div>
    <div class="form-field-wrapper">
      <div class="form-field">
        <InputText v-model="reservationData.exhibitorDetails.streetName" name="exhibitor_streetname" :label="t.exhibitor_streetname" type="text" :min-length="2" :max-length="100" required/>
      </div>
      <div class="form-field">
        <InputText v-model="reservationData.exhibitorDetails.houseNumber" name="exhibitor_housenumber" :label="t.exhibitor_housenumber" type="text" :min-length="1" :max-length="10" required/>
      </div>
    </div>
    <div class="form-field-wrapper">
      <div class="form-field">
        <InputText v-model="reservationData.exhibitorDetails.postcode" name="exhibitor_postcode" :label="t.exhibitor_postcode" type="text" :min-length="4" :max-length="7" pattern="^(\d{4}\s?[A-Z]{2}|\d{5}|\d{4})$" placeholder="e.g. 1234AB, 12345, 1234" required/>
      </div>
      <div class="form-field">
        <InputText v-model="reservationData.exhibitorDetails.cityName" name="exhibitor_cityname" :label="t.exhibitor_cityname" type="text" :min-length="2" :max-length="50" required/>
      </div>
    </div>
    <div class="form-field">
      <InputText v-model="reservationData.exhibitorDetails.website" name="exhibitor_website" :label="t.exhibitor_website" placeholder="www.website.nl" type="text" :min-length="4" :max-length="200" />
      <span class="field_help_text">Voer alleen het domein in (bijvoorbeeld: www.website.nl). Voeg geen http:// of https:// toe.</span>
    </div>
    <br/>
    <h2>{{ t.billing }}</h2>
    <div class="form-field">
      <InputText v-model="reservationData.billing.chamberOfCommerceNumber" name="billing_chamberofcommercenumber" :label="t.billing_chamberofcommercenumber" type="text" :min-length="8" :max-length="15"/>
    </div>
    <div class="form-field">
      <InputText v-model="reservationData.billing.vatNumber" name="billing_vatnumber" :label="t.billing_vatnumber" type="text" :min-length="11" :max-length="14" @update:modelValue="handleVatNumberInput" required/>
    </div>
    <div class="form-field">
      <InputText v-model="reservationData.billing.email" name="billing_email" :label="t.billing_email" type="email" :min-length="5" :max-length="254" required/>
    </div>
    <br/>
    <a href="#" @click.prevent="copyExhibitorDetailsToBilling" class="copy-link"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free v7.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M288 64C252.7 64 224 92.7 224 128L224 384C224 419.3 252.7 448 288 448L480 448C515.3 448 544 419.3 544 384L544 183.4C544 166 536.9 149.3 524.3 137.2L466.6 81.8C454.7 70.4 438.8 64 422.3 64L288 64zM160 192C124.7 192 96 220.7 96 256L96 512C96 547.3 124.7 576 160 576L352 576C387.3 576 416 547.3 416 512L416 496L352 496L352 512L160 512L160 256L176 256L176 192L160 192z"/></svg> {{ t.use_exhibitor_data }}</a>
    <div class="form-field-wrapper">
      <div class="form-field">
        <InputText v-model="reservationData.billing.streetName" name="billing_streetname" :label="t.billing_streetname" type="text" :min-length="2" :max-length="100" required/>
      </div>
      <div class="form-field">
        <InputText v-model="reservationData.billing.houseNumber" name="billing_housenumber" :label="t.billing_housenumber" type="text" :min-length="1" :max-length="10" required/>
      </div>
    </div>
    <div class="form-field-wrapper">
      <div class="form-field">
        <InputText v-model="reservationData.billing.postcode" name="billing_postcode" :label="t.billing_postcode" type="text" :min-length="4" :max-length="7" pattern="^(\d{4}\s?[A-Z]{2}|\d{5}|\d{4})$" placeholder="e.g. 1234AB, 12345, 1234" required/>
      </div>
      <div class="form-field">
        <InputText v-model="reservationData.billing.cityName" name="billing_cityname" :label="t.billing_cityname" type="text" :min-length="2" :max-length="50" required/>
      </div>
    </div>


    <!-- Additional Exhibitors Section -->
    <AdditionalExhibitorsManager />
    <br/>
    <h2>{{ t.billing_delivery_method }}</h2>
    <div class="form-field">
        <RadioButton :options="[{value: 'by_mail', label: t.billing_delivery_by_mail}, {value: 'by_email', label: t.billing_delivery_by_email} ]" name="billing_delivery_method" v-model="reservationData.billing.deliveryMethod" />
    </div>
    <div>&nbsp;</div>
    <div class="form-field">
      <label for="billing_delivery_description">
        <br/>
        <h2>{{ t.billing_delivery_description }}</h2>
        <TextArea name="billing_delivery_description" v-model="reservationData.billing.description" />
      </label>
    </div>
  </form>
</template>


<script>

import InputText from "@/components/shared/FormElements/InputText.vue";
import useReservationData from "@/composables/useReservationData";
import useStepNavigation from "@/composables/useStepNavigation";
import RadioButton from "@/components/shared/FormElements/RadioButton.vue";
import TextArea from "@/components/shared/FormElements/TextArea.vue";
import AdditionalExhibitorsManager from "./AdditionalExhibitorsManager.vue";
import {ref, watch} from "vue";
import {apiFinalizeReservation} from "@/api/endpoints";
import useSpinner from "@/composables/useSpinner";
import useTexts from "@/composables/useTexts";
import useMessages from "@/composables/useMessages";

export default {
  name: "ReservationData",
  components: {
    TextArea,
    RadioButton,
    InputText,
    AdditionalExhibitorsManager
  },
  setup() {
    const { reservationData } = useReservationData();
    const { nextButtonEnabled, nextButtonPressed, goToNextStep } = useStepNavigation();
    const { showSpinner, hideSpinner } = useSpinner();
    const { getTextsForComponent } = useTexts();
    const { showMessage } = useMessages();
    const t = getTextsForComponent('ReservationData')

    const form = ref(null);

    const copyExhibitorDetailsToBilling = () => {
      reservationData.value.billing.streetName = reservationData.value.exhibitorDetails.streetName;
      reservationData.value.billing.houseNumber = reservationData.value.exhibitorDetails.houseNumber;
      reservationData.value.billing.postcode = reservationData.value.exhibitorDetails.postcode;
      reservationData.value.billing.cityName = reservationData.value.exhibitorDetails.cityName;
    };

    nextButtonEnabled.value = true;

    watch(nextButtonPressed, async (isPressed) => {
      if (isPressed) {
        if (form.value.checkValidity()) {
          showSpinner()
          try {
            await apiFinalizeReservation(reservationData.value);
            hideSpinner();
            goToNextStep();
          } catch (error) {
            hideSpinner();
            nextButtonPressed.value = false;
            showMessage(t.finalize_error);
          }
        } else {
          nextButtonPressed.value = false;
          form.value.reportValidity()
        }
      }
    });

    /* Make VatNumber uppercase automatically */
    const handleVatNumberInput = (value) => {
      reservationData.value.billing.vatNumber = value.toUpperCase();
    };

    return {
      reservationData,
      nextButtonPressed,
      copyExhibitorDetailsToBilling,
      form,
      handleVatNumberInput,
      t
    }
  }
};
</script>

<style scoped>
.rvr-data-form {
  background-color: #ffffff;
  padding: 20px;
  border-radius: 4px;
}
.copy-link {
  svg {
    height: 16px;
    position: relative;
    top: 2px;
    fill: white;
  }
}

.field_warning_text {
  position: relative;
  background: #fcd700;
  display: block;
  padding: 10px;
  line-height: 1.2em;
  font-size: 0.9em;
  border-radius: 5px;
}

.form-field {
  margin-bottom: 10px;
}

.field_warning_text:after {
  position: absolute;
  left: 48%;
  bottom: -20px;
  content: '';
  width: 0;
  height: 0;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-top: 20px solid #fcd700;
}

.field_help_text {
  display: block;
  margin-top: 5px;
  font-size: 0.85em;
  color: #666;
  font-style: italic;
}

@media (max-width: 768px) {
  .field_warning_text::after {
    left: 70%;
  }
}
</style>
